// services/statistic-data/hooks/useStatisticOverview.ts

import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { StatisticOverviewResponseSchema } from "../response/StatisticOverviewResponse";

const API_VERSION = "v4";

// Interface untuk parameter filter
interface ParamsStatisticOverview {
    property_id?: string;
    start_date?: string;
    end_date?: string;
}

// Interface untuk props yang diterima oleh hook
interface StatisticOverviewProps {
    filters: ParamsStatisticOverview;
}

const useStatisticOverview = (query: StatisticOverviewProps) => {
    return useQuery({
        // Kunci query yang unik untuk caching, termasuk filter yang aktif
        queryKey: [
            'statistic-overview',
            ...Object.entries(query.filters ?? {})
                .map(([key, value]) => `${key}:${value}`),
        ],
        queryFn: async () => {
            try {
                // Membuat objek params dan memfilter properti yang tidak memiliki nilai
                const params = {
                    filter: Object.fromEntries(
                        Object.entries(query.filters ?? {}).filter(([_key, value]) => value !== undefined && value !== null && value !== "")
                    ),
                };

                // Melakukan request ke API dengan endpoint baru
                const response = await privateApi.get(`/${API_VERSION}/channel-manager/statistics/overview`, { params });

                // Validasi respons menggunakan skema Zod
                const validationResult = StatisticOverviewResponseSchema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid Statistic Overview data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch Statistic Overview`, error);
                throw error;
            }
        },
        // Konfigurasi tambahan dari hook sebelumnya
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false,
    });
};

export default useStatisticOverview;